import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';

import useAppContext from 'conf/AppContext';


export default function ScorePage() {
  const appContext = useAppContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const abortController = new AbortController();
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/profileWithTechStackAndGitHub', {
          parseJson: true,
        }, abortController);
        setData(rez?.data?.user);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
          navigate('/');
        }
        setError(err);
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();

    return () => {
      abortController.abort();
    };

  }, []);
  
  return <div>Coming soon...</div>;
}
